/* @flow */

import {
  templateContainer,
  templateItem,
  sideBarTabletWidth,
  sideBarLapWidth,
  navBarMobileHeight,
  mainTabletWidth,
  mainLapWidth,
} from './style/template.style';
import { tablet, lap } from '@e180/ui/lib/token/mediaQuery';
import { gridTemplate, gridStart } from 'src/shared/app/base/style/util/grid';

export default {
  root: {
    extend: templateContainer,

    // `auto` doesn't seem supported by IE11
    ...gridTemplate('1fr', `1fr ${navBarMobileHeight}px`),

    [tablet]: {
      ...gridTemplate(`${sideBarTabletWidth}px ${mainTabletWidth}px`, '1fr'),
    },
    [lap]: {
      ...gridTemplate(`${sideBarLapWidth}px ${mainLapWidth}px`, '1fr'),
    },
  },
  main: {
    extend: templateItem,

    ...gridStart(1, 1),

    [tablet]: {
      ...gridStart(2, 1),
    },
  },
  aside: {
    extend: templateItem,

    position: 'fixed',
    left: 0,
    bottom: 0,

    ...gridStart(1, 2),

    [tablet]: {
      top: 0,
      bottom: 'auto',

      ...gridStart(1, 1),
    },
  },
};
